<div class="step-layout" [style.height]="containerHeight">
  <!-- Date Configuration -->
  <div class="config-card info-card p-3" fxLayout="column" fxLayoutGap="15px" fxFlex="50">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon>calendar_today</mat-icon>
      <span class="subtitle-default">Term & Dates</span>
    </div>
    <div>
      <!-- Pre-selected dates display -->
      <div *ngIf="selectedDates.length > 0" class="pre-selected-info btn-cursor"
           (click)="toggleFullSelectedDates('preselected')">
        <h4>Pre-selected Dates</h4>
        <div class="date-count">{{ selectedDates.length }} dates selected from calendar</div>
        <div
          class="date-preview">{{ showFullPreselectedDates ? getPreSelectedDatesFull() : getPreSelectedDatesPreview() }}
        </div>
      </div>

      <!-- Date Range -->
      <div class="date-range">
        <mat-form-field class="custom-date-picker full-width" appearance="outline" floatLabel="always">
          <mat-label>Start Date</mat-label>
          <input [(ngModel)]="bookingConfig.startDate" [matDatepicker]="startPicker"
                 matInput
                 placeholder="yyyy/mm/dd"
                 (ngModelChange)="onSelectDateRange()"
          />
          <mat-datepicker-toggle matIconSuffix [for]="startPicker">
            <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="custom-date-picker full-width" appearance="outline" floatLabel="always">
          <mat-label>End Date</mat-label>
          <input [(ngModel)]="bookingConfig.endDate" [matDatepicker]="endPicker"
                 matInput
                 placeholder="yyyy/mm/dd"
                 (ngModelChange)="onSelectDateRange()"
          />
          <mat-datepicker-toggle matIconSuffix [for]="endPicker">
            <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
          </mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <!-- Pattern Selection for Complex Bookings -->
      <div *ngIf="bookingConfig.startDate && bookingConfig.endDate"
           class="pattern-section">
        <label class="section-label">Occupancy Pattern</label>
        <mat-radio-group [(ngModel)]="bookingConfig.patternType" (ngModelChange)="updatePatternType()"
                         class="pattern-group" color="primary">
          <mat-radio-button value="MONTHLY">Monthly</mat-radio-button>
          <mat-radio-button value="WEEKENDS">Weekends only (Sat-Sun)</mat-radio-button>
          <mat-radio-button value="WEEKLY">Weekly (All days)</mat-radio-button>
          <mat-radio-button value="WEEKLY_CUSTOM">Weekly (Specific days)</mat-radio-button>
          <mat-radio-button value="DAILY_CUSTOM">Custom selection</mat-radio-button>
        </mat-radio-group>

        <!-- Weekend Options -->
        <div *ngIf="bookingConfig.patternType === PatternType.WEEKENDS" class="weekend-options">
          <mat-checkbox
            [checked]="bookingConfig.patternType ===  PatternType.WEEKENDS && bookingConfig.includeDays.includes('Friday')"
            (change)="toggleIncludeFridays($event)">
            Include Fridays
          </mat-checkbox>
        </div>

        <!-- Custom Days Selection -->
        <div *ngIf="bookingConfig.patternType ===  PatternType.WEEKLY_CUSTOM" class="custom-days">
          <label class="section-label">Select days:</label>
          <div class="days-grid">
            <mat-checkbox
              *ngFor="let day of weekDays"
              [checked]="bookingConfig.includeDays.includes(day)"
              (change)="toggleCustomDay(day)"
            >
              {{ day }}
            </mat-checkbox>
          </div>
        </div>
      </div>

      <!-- Effective Dates Preview -->
      <div *ngIf="selectedDates.length > 0" class="effective-dates btn-cursor"
           (click)="toggleFullSelectedDates('selected')">
        <h4>Actual Dates ({{ selectedDates.length }} days)</h4>
        <div class="dates-preview">{{ showFullSelectedDates ? getEffectiveDatesFull() : getEffectiveDatesPreview() }}
        </div>
      </div>
    </div>
  </div>

  @if (isSubLease) {
    <!-- Available Space -->
    <div class="spaces-container info-card p-3" fxLayout="column" fxLayoutAlign="start center" fxFlex="50"
         fxLayoutGap="15px">
      <div class="full-width" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <mat-icon>location_on</mat-icon>
        <span class="subtitle-default">Reserve Space</span>
      </div>

      <app-shared-space-selection-list class="full-width"
                                [subLeaseSize]="reservedSpace"
                                [availableSpace]="availableSharedSpace"
                                [warnOnUnavailableSelection]="true"
                                [listHeight]="availableSpaces.partiallyAvailable.length > 0 ? '430px' : '490px'"
                                (onSpaceSizeChange)="onSharedSpaceSizeChange($event)">
      </app-shared-space-selection-list>
    </div>
  } @else {
    <!-- Available Spaces -->
    <div class="spaces-container info-card p-3" fxLayout="column" fxLayoutAlign="start center" fxFlex="50"
         fxLayoutGap="15px">
      <div class="full-width" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <mat-icon>location_on</mat-icon>
        <span class="subtitle-default">Available Spaces</span>
        <mat-chip-set *ngIf="selectedDates.length > 0">
          <mat-chip>{{ availableSpaces.fullyAvailable.length }} available</mat-chip>
        </mat-chip-set>
      </div>

      <app-space-selection-list class="full-width"
                                [selectedSpaces]="selectedSpaces"
                                [availableSpaces]="availableSpaces"
                                [bookingConfig]="bookingConfig"
                                [allIndustries]="allIndustries"
                                [warnOnUnavailableSelection]="true"
                                [listHeight]="availableSpaces.partiallyAvailable.length > 0 ? '430px' : '490px'"
                                (onSelectSpace)="onSelectSpace($event)">
      </app-space-selection-list>
    </div>
  }


</div>

<!-- Navigation for Step 2 -->
<div class="navigation-card info-card p-3">
  <div class="navigation-buttons">
    <button class="button-secondary" mat-flat-button (click)="prevStep()">Back</button>
    <button class="button-primary" mat-flat-button
            (click)="nextStep()"
            [disabled]="disableNextButton">
      <div class="button-text">Configure Rates & Charges</div>
    </button>
  </div>
</div>
